module.exports = __webpack_public_path__ + "media/images/landing/icon-snacks-bb8d66b2535196de894d39a530a9fdf3.svg";